<template>
  <div class="flex sm:mx-2 bg-theme-font text-white py-3 my-4 px-2 sm:px-0 ">
    <div class="flex flex-col items-center gap-2 max-w-2xl mx-auto">
      <h3 class="text-white">{{ $t('spotdetail.report_spot_title') }}</h3>
      <i18n-t keypath="spotdetail.report_spot_text" scope="global" tag="p" class="text-white"
      >
        <template v-slot:guidelines>
          <NuxtLink to="/guidelines">{{ $t('spotdetail.report_spot_guidelines') }}
          </NuxtLink>
        </template>
      </i18n-t>
      <ButtonSubmit
        :disable-submit="reported"
        :color="'white'"
        onclick="confirm_report_modal.showModal()"
        :title="
          reported
            ? $t('spotdetail.report_spot_button_already_reported')
            : $t('spotdetail.report_spot_button_text')
        "
      />
      <Modal id="confirm_report_modal">
        <div class="flex flex-col gap-2">
          <h2 class="text-black mr-2 mb-3"> {{ $t('spotdetail.report_spot_title') }}</h2>
          <i18n-t keypath="spotdetail.report_spot_text" scope="global" tag="p"
          >
            <template v-slot:guidelines>
              <NuxtLink to="/guidelines">{{ $t('spotdetail.report_spot_guidelines') }}
              </NuxtLink>
            </template>
          </i18n-t>
          <ButtonSubmit
            :loading="loading"
            :error="error"
            :disable-submit="reported"
            @click="reportSpot()"x
            :title="
          reported
            ? $t('spotdetail.report_spot_button_already_reported')
            : $t('spotdetail.report_spot_button_text')
        "
          />
        </div>
      </Modal>
    </div>
  </div>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp()

const loading = ref<boolean>(false);
const error = ref<boolean>(false);
const props = defineProps<{ spot: SpotDetail, reported?: boolean }>();

const reported = ref<boolean>(props.reported);

watch(
  () => props.reported,
  (value) => {
    reported.value = value;
  }
);

function reportSpot() {
  loading.value = true;
  error.value = false;

$api<boolean>('/spots/' + props.spot.id + '/report', { method: 'POST' })
    .then(() => {
      reported.value = true;
      loading.value = false;
      (document.getElementById("confirm_report_modal") as HTMLFormElement).close();
    })
    .catch((  error) => {
      error.value = true;
    });
}
</script>
